import { mutator } from 'satcheljs';
import { getProfileStore } from 'owa-mail-account-store';
import { default as initializeAccountStore } from '../actions/initializeAccountStore';

export default mutator(initializeAccountStore, actionMessage => {
    const store = getProfileStore();
    store.accountSources = actionMessage.sources;
    store.selectedAccountSourceId = actionMessage.selectedSourceId;
});
